function ApplicationList() {

}

ApplicationList.events = {
    isInit: true,

    init: function() {
        var self = this;

        if (self.isInit) {
            $("#prolook-application-list").on("click", ".select-application", self.onSelectApplication);
            self.isInit = false;
        } 
    },

    onSelectApplication: function() {
        var applicationCode = $(this).closest(".application-item").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(applicationCode);

        if (typeof applicationSettings !== "undefined") {
            if (applicationSettings.application_type !== "free") {
                ub.funcs.activateApplications(applicationSettings.code);
            } else {
                ub.funcs.activateFreeApplication(applicationSettings.code);
            }
        }

        UIkit.modal("#prolook-application-list").hide();
    }
};


ApplicationList.render = function(applicationIDs) {
    var tmpl = _.template($("#prolook-application-list-template").html());
    var applicationList = [];

    _.each(applicationIDs, function(id) {
        var applicationObject = ub.funcs.getApplicationSettings(id);

        if (typeof applicationObject === "undefined") return;

        if (ApplicationCore.utilities.isPlayerNumber(applicationObject.application_type) ||
            applicationObject.application_type === "team_name" ||
            applicationObject.application_type === "player_name"
        ) {
            applicationList.push({
                code: applicationObject.code,
                type: applicationObject.application_type.toTitleCase(),
                name: applicationObject.text
            });
        } else if (applicationObject.application_type === "mascot") {
            applicationList.push({
                code: applicationObject.code,
                type: "Stock Mascot",
                name: applicationObject.mascot.name
            });

        } else if (applicationObject.application_type === "embellishments") {
            if (TextShapeCore.utilities.isTextShape(applicationObject.code)) {
                applicationList.push({
                    code: applicationObject.code,
                    type: applicationObject.textLayoutType.toTitleCase(),
                    name: applicationObject.text
                });
            } else {
                applicationList.push({
                    code: applicationObject.code,
                    type: "Custom Mascot",
                    name: applicationObject.embellishment.name
                });
            }
        } else if (applicationObject.application_type === "free") {
            applicationList.push({
                code: applicationObject.code,
                type: applicationObject.application_type,
                name: applicationObject.application_type
            });
        }
    });

    $("#prolook-application-list .application-list").html("");
    $("#prolook-application-list .application-list").html(tmpl({
        applications: applicationList
    }));

    ApplicationList.events.init();

    UIkit.modal("#prolook-application-list").show();
};